import React, { useRef, useState, useEffect } from 'react';
import { Subcategories, Category, SubcategoriesWrapper, Title, GridWrapper, MainDescription, DescriptionContent, Heading } from './index.styled';
import { TopPortfolios } from '../TopPortfolios';
import { PatentsGrid } from '../PatentsGrid';
import { useTranslation } from 'react-i18next';
import Fade from 'react-reveal/Fade';

export const PortfolioCategorySubNav = ({ category }) => {
  const categoriesRef = useRef(null);
  const { t } = useTranslation();
  const portfolioCategories = t(`PortfolioCategories`, { returnObjects: true });
  let [defaultCategory] = portfolioCategories.filter(item => item.name === category)

  //Method: clears all cells
  const clearSelected = categories => categories.map(category => category.classList.remove('active'));
  //Method: returns the portfolios data given a category name
  const getPortfoliosData = categoryName => portfolioCategories.filter(category => category.name === categoryName)

  useEffect(() => {
    const categories = Array.from(categoriesRef.current.children);
    clearSelected(categories)
    const [initial] = categories.filter(item => item.getAttribute('value') === category)
    initial.classList.add('active')
  }, [category])

  const setVisited = e => {
    const active = e.target;
    const categories = Array.from(categoriesRef.current.children);
    const categoryNameSelected = active.getAttribute('value');
    const portfoliosData = getPortfoliosData(categoryNameSelected);
    clearSelected(categories);
    active.classList.add('active');
    defaultCategory = portfoliosData[0];
  }

  return (
    <>
      <Heading>
        <Title>{t('CategoriesData.title')}</Title>
      </Heading>
      <SubcategoriesWrapper>
        <Fade up>
          <Subcategories ref={categoriesRef} >
            {portfolioCategories.map(category => (
              <Category
                onClick={e => setVisited(e)}
                key={category.name}
                to={`/portfolios/${category.name}`}
                value={category.name}
              >
                {t(`CategoriesData.categories.${category.name}`)}
              </Category>
            ))}
          </Subcategories>
        </Fade>
      </SubcategoriesWrapper>
      <GridWrapper>
        <Fade up>
          <MainDescription>
            <DescriptionContent>
              {defaultCategory.description}
            </DescriptionContent>
          </MainDescription>
        </Fade>
        <TopPortfolios path='/portfolios/:section' name={category} />
        <PatentsGrid path='/portfolios/:section' name={category} />
      </GridWrapper>
    </>
  )
}
